import React, { useCallback, useEffect, useMemo } from "react";

// //devextreme
import List from "devextreme-react/list";
import ArrayStore from "devextreme/data/array_store";

//helpers
import { useWindowDimensions } from "@app/contexts";
import {
  listReportsSetTempUiKV,
  selectListReportUi_groups,
  selectListReportUi_loadedUi,
  selectListReportUi_tempUi,
} from "@app/state/insider/ui/uiList";
import "@app/style/dx.generic.karmaGunMetal.css";

import { useAppDispatch, useAppSelector } from "../../state";
import "./lists_common.scss";

export const ListOfGroups = () => {
  const dispatch = useAppDispatch();
  const { height: fullHeight } = useWindowDimensions();
  const theListGroups = useAppSelector(selectListReportUi_groups);
  const theLoadedUi = useAppSelector(selectListReportUi_loadedUi);
  const theSelectingState = useAppSelector(selectListReportUi_tempUi);

  const { lxGroupId, lxReportId } = useMemo(
    () => theSelectingState,
    [theSelectingState.lxGroupId, theSelectingState.lxReportId]
  );

  const dataSourceOptions = {
    store: new ArrayStore({
      data: theListGroups,
      key: "id",
    }),
    searchExpr: ["name"],
  };

  function renderListItem(item: any) {
    return (
      <div className="lil">
        <div className="lil-title">
          <div
            className={`lil-name ${
              theLoadedUi.lxGroupId === item.id ? "selected-icon" : ""
            }`}
          >
            {item.displayName || item.name}
          </div>
        </div>
        <div className="lil-footer">{item.text}</div>
      </div>
    );
  }

  const handleListSelectionChange = useCallback(
    (e: any) => {
      // console.log('e groupId', e);
      const currentList = e.addedItems[0];
      dispatch(
        listReportsSetTempUiKV({
          lxGroupId: currentList.id,
          lxReportId: null,
        })
      );
    },
    [lxGroupId, lxReportId]
  );
  useEffect(() => {
    if (theListGroups?.length && !lxGroupId) {
      dispatch(
        listReportsSetTempUiKV({
          lxGroupId: theListGroups[0].id,
          lxReportId: null,
        })
      );
    }
  }, [lxGroupId, theListGroups]);
  return (
    <List
      id={"list-of-lists"}
      className={"dx-swatch-karmaGunMetal"}
      height={fullHeight ?? 0}
      selectionMode="single"
      dataSource={dataSourceOptions}
      grouped={false}
      searchEnabled={false}
      selectedItemKeys={[lxGroupId || theListGroups?.[0]?.id]}
      onSelectionChanged={handleListSelectionChange}
      itemRender={renderListItem}
      focusStateEnabled={false}
      noDataText={""}
    />
  );
};
